const languageData = [
  {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
  },
  {
    languageId: "german",
    locale: "de",
    name: "Deutschland",
    icon: "de",
  },
  {
    languageId: "french",
    locale: "fr",
    name: "Français",
    icon: "fr",
  },
  {
    languageId: "italian",
    locale: "it",
    name: "Italiano",
    icon: "it",
  },
  {
    languageId: "russian",
    locale: "ru",
    name: "Русский",
    icon: "ru",
  }
];

export default languageData;
